import React, { useCallback, useContext, useRef, useState } from "react";
import { Card, Table } from "@themesberg/react-bootstrap";
import { TableRow } from "../component/TableRow";
import Pagination from "../../../../components/Pagination";
import { Context } from "../Period";
import AddResultPopup from "../sub-screen/add-result-popup/AddResultPopup";
import CalculateRewardPopup from "../sub-screen/calculate-reward-popup/CalculateRewardPopup";
import { getList } from "../../../../controller/api/__classic__/result";
import { useCookies } from "react-cookie";
import { calculatePage } from "../../../../helper/helper";

const _Table = () => {
  const { state, dispatch } = useContext(Context);
  const { region } = state.filter;

  const [cookies] = useCookies(["lottmekong"]);

  const [addPopupShow, setAddPopupShow] = useState(false);

  const [modalCalculateRewardShow, setModalCalculateRewardShow] =
    useState(false);

  const resultIdRef = useRef(null);

  const resultRef = useRef(null);

  const resultCallbackRef = useRef(() => {});

  const canUpdateResultRef = useRef(false);

  const channelNameRef = useRef('');

  const refreshData = useCallback(async () => {
    const response = await getList(
      cookies.lottmekong,
      {
        from: state.filter.from,
        to: state.filter.to,
        region: region,
      },
      state.filter.page,
    );

    if (response) {
      dispatch({
        type: "UPDATE_DATA",
        payload: {
          list: response.data,
          total: response.total,
          classicUser: response.classicUser,
          totalPage: calculatePage(response.total),
        },
      });
    }
  }, [
    cookies.lottmekong,
    state.filter.from,
    state.filter.to,
    state.filter.page,
    region,
    dispatch,
  ]);

  const onShowAddPopupPress = (id, result, callback, canUpdate, channelName) => {
    resultIdRef.current = id;
    resultRef.current = result;
    canUpdateResultRef.current = canUpdate;
    resultCallbackRef.current = callback;
    channelNameRef.current = channelName;
    setAddPopupShow(true);
  };

  const onShowCalculateRewardPopupPress = (resultId) => {
    resultIdRef.current = resultId;
    setModalCalculateRewardShow(true);
  };

  const onHideCalculateRewardPopupPress = (
    totalRewardTicket,
    totalUnrewardTicket,
    callback,
  ) => {
    callback();

    setModalCalculateRewardShow(false);
    refreshData();
    resultIdRef.current = null;
  };

  return (
    <>
      <Card border="light" className="shadow-sm mb-4 border-0">
        <Card.Body className="p-0">
          <div className="table-responsive">
            <Table
              className="table-centered table-nowrap mb-0 rounded align-middle"
              hover
            >
              <thead className="bg-white border-bottom">
                <tr>
                  <th
                    className="border-bottom py-3 ps-4 text-uppercase small fw-bold text-muted"
                    scope="col"
                    style={{ width: "350px" }}
                  >
                    Kênh / Ngày quay
                  </th>
                  <th
                    className="border-bottom py-3 text-uppercase small fw-bold text-muted"
                    scope="col"
                  >
                    Kết quả xổ số
                  </th>
                  <th
                    className="border-bottom text-center py-3 text-uppercase small fw-bold text-muted"
                    scope="col"
                    style={{ width: "180px" }}
                  >
                    Trạng thái
                  </th>
                  <th
                    className="border-bottom text-center py-3 pe-4 text-uppercase small fw-bold text-muted"
                    scope="col"
                    style={{ width: "160px" }}
                  >
                    Thao tác
                  </th>
                </tr>
              </thead>
              <tbody>
                {state.data.list &&
                  state.data.list.map((pv, index) => (
                    <TableRow
                      classicUser={state.data.classicUser}
                      onCalculateRewardPress={onShowCalculateRewardPopupPress}
                      handleAddResult={onShowAddPopupPress}
                      rIndex={index}
                      key={`table-keys-lottmekong-${pv.id}`}
                      {...pv}
                    />
                  ))}
                {(!state.data.list || state.data.list.length === 0) && (
                  <tr>
                    <td colSpan="4" className="text-center py-5 text-muted">
                      <div className="fs-5">Chưa có dữ liệu</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Card.Body>
        <Card.Footer className="px-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
          <div className="fw-normal small mt-1 mt-lg-0 text-muted">
            Hiển thị <b>{state.data.list?.length || 0}</b> trong tổng{" "}
            <b>{state.data.total || 0}</b> kỳ quay
          </div>
          <Pagination
            totalPage={state.data.totalPage || 0}
            currentPage={state.filter.page || 0}
            onPageChange={(i) => {
              dispatch({
                type: "UPDATE_PAGE",
                payload: i,
              });
            }}
          />
        </Card.Footer>
      </Card>
      <AddResultPopup
        show={addPopupShow}
        id={resultIdRef.current}
        result={resultRef.current}
        callback={resultCallbackRef.current}
        canUpdate={canUpdateResultRef.current}
        region={region}
        channelName={channelNameRef.current}
        onHide={() => {
          resultIdRef.current = null;
          resultCallbackRef.current = () => {};
          channelNameRef.current = '';
          setAddPopupShow(false);
        }}
      />

      <CalculateRewardPopup
        show={modalCalculateRewardShow}
        resultId={resultIdRef.current}
        onHide={onHideCalculateRewardPopupPress}
      />
    </>
  );
};

export default React.memo(_Table);
